import { DriverDetails } from '@acorn-portal/shared/src/services/api';
import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';

export const mapPcDriverToDriverDetails = (driver: PcDriver): DriverDetails => {
	const baseData: DriverDetails = {
		title: driver.title,
		firstName: driver.firstName,
		lastName: driver.lastName,
		isPolicyholder: driver.mainDriver ?? false,
		mainDriver: driver.mainDriver ?? false,
		dataPointId: driver.driverId ?? '',
	};

	if (driver.licencePassedDate) {
		baseData.badgePassedDate = driver.licencePassedDate;
	}

	return {
		...baseData,
	};
};
